export const categories = [
  { slug: 'shaonian', name: '少年漫画', icon: 'ri-sword-line', count: 1280 },
  { slug: 'lianai', name: '恋爱漫画', icon: 'ri-heart-line', count: 956 },
  { slug: 'rexue', name: '热血漫画', icon: 'ri-fire-line', count: 1134 },
  { slug: 'xuanhuan', name: '玄幻漫画', icon: 'ri-magic-line', count: 872 },
  { slug: 'gaoxiao', name: '搞笑漫画', icon: 'ri-emotion-laugh-line', count: 643 },
  { slug: 'kongbu', name: '恐怖漫画', icon: 'ri-ghost-line', count: 421 },
  { slug: 'kehuan', name: '科幻漫画', icon: 'ri-rocket-line', count: 538 },
  { slug: 'xuanyi', name: '悬疑漫画', icon: 'ri-search-eye-line', count: 387 },
  { slug: 'guzhuang', name: '古装漫画', icon: 'ri-vip-crown-line', count: 712 },
  { slug: 'xiuzhen', name: '修真漫画', icon: 'ri-star-line', count: 498 },
];

export const comics = [
  {
    id: 1,
    title: '蜜桃少年',
    slug: 'mitao-shaonian',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Chinese%20manhua%20cover%20featuring%20a%20handsome%20young%20man%20with%20peach%20blossom%20background%2C%20soft%20pink%20and%20warm%20tones%2C%20stylized%20anime%20art%20style%2C%20clean%20composition%2C%20minimal%20background%20with%20floating%20petals%2C%20romantic%20atmosphere%2C%20high%20quality%20illustration&width=600&height=800&seq=comic-01&orientation=portrait',
    category: 'shaonian',
    author: '墨白工作室',
    status: '连载中',
    rating: 9.6,
    views: 12850000,
    chapters: 186,
    updatedAt: '2026-08-04',
    description: '少年林枫意外获得神秘力量，在成长的道路上结识了一群志同道合的伙伴，共同面对来自各方的挑战与考验...',
    tags: ['热血', '成长', '友情', '冒险'],
  },
  {
    id: 2,
    title: '星辰大海',
    slug: 'xingchen-dahai',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20cover%20with%20a%20young%20man%20gazing%20at%20starry%20sky%2C%20deep%20blue%20and%20gold%20accents%2C%20fantasy%20adventure%20theme%2C%20stylized%20anime%20art%2C%20celestial%20elements%2C%20clean%20minimal%20composition%2C%20high%20quality%20illustration&width=600&height=800&seq=comic-02&orientation=portrait',
    category: 'xuanhuan',
    author: '星河工作室',
    status: '已完结',
    rating: 9.3,
    views: 9650000,
    chapters: 240,
    updatedAt: '2026-07-28',
    description: '在遥远的未来，人类已经征服了星辰大海。少年宇航员在探索未知星系时，发现了一个惊天秘密...',
    tags: ['科幻', '冒险', '宇宙', '机甲'],
  },
  {
    id: 3,
    title: '花间少年',
    slug: 'huajian-shaonian',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20Chinese%20manhua%20cover%20with%20cherry%20blossoms%20and%20a%20couple%20under%20a%20tree%2C%20soft%20pink%20and%20white%20tones%2C%20gentle%20romance%20theme%2C%20stylized%20anime%20art%2C%20spring%20atmosphere%2C%20clean%20composition%2C%20high%20quality%20illustration&width=600&height=800&seq=comic-03&orientation=portrait',
    category: 'lianai',
    author: '花开富贵',
    status: '连载中',
    rating: 9.5,
    views: 11020000,
    chapters: 156,
    updatedAt: '2026-08-03',
    description: '校园里的青涩恋情，花间少年与少女的美妙邂逅，一段纯真又动人的青春故事就此展开...',
    tags: ['校园', '恋爱', '青春', '治愈'],
  },
  {
    id: 4,
    title: '烈焰战魂',
    slug: 'lieyan-zhanhun',
    cover: 'https://readdy.ai/api/search-image?query=A%20fiery%20Chinese%20manhua%20cover%20with%20a%20warrior%20in%20flames%2C%20red%20and%20orange%20dynamic%20tones%2C%20battle%20scene%20theme%2C%20stylized%20anime%20art%2C%20intense%20action%20atmosphere%2C%20clean%20composition%2C%20high%20quality%20illustration&width=600&height=800&seq=comic-04&orientation=portrait',
    category: 'rexue',
    author: '战火漫画',
    status: '连载中',
    rating: 9.1,
    views: 8920000,
    chapters: 198,
    updatedAt: '2026-08-04',
    description: '战争年代，一位少年挺身而出，以炽热的战魂保卫家园，谱写了一段可歌可泣的英雄传奇...',
    tags: ['战斗', '热血', '英雄', '战争'],
  },
  {
    id: 5,
    title: '仙路争锋',
    slug: 'xianlu-zhengfeng',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20cultivation%20manhua%20cover%20with%20a%20swordsman%20on%20a%20mountain%20peak%2C%20ethereal%20white%20and%20gold%20tones%2C%20xianxia%20theme%2C%20stylized%20anime%20art%2C%20misty%20atmosphere%2C%20clean%20composition%2C%20high%20quality%20illustration&width=600&height=800&seq=comic-05&orientation=portrait',
    category: 'xiuzhen',
    author: '清风漫画',
    status: '连载中',
    rating: 9.4,
    views: 10500000,
    chapters: 320,
    updatedAt: '2026-08-02',
    description: '修真界风云变幻，一个平凡少年踏上修仙之路，在无尽的争锋中逐渐成长为一代仙尊...',
    tags: ['修仙', '玄幻', '升级', '战斗'],
  },
  {
    id: 6,
    title: '幽夜诡谈',
    slug: 'youye-guitan',
    cover: 'https://readdy.ai/api/search-image?query=A%20horror%20Chinese%20manhua%20cover%20with%20dark%20alley%20and%20mysterious%20shadow%2C%20dark%20purple%20and%20black%20tones%2C%20supernatural%20theme%2C%20stylized%20anime%20art%2C%20eerie%20atmosphere%2C%20clean%20composition%2C%20high%20quality%20illustration&width=600&height=800&seq=comic-06&orientation=portrait',
    category: 'kongbu',
    author: '暗夜创作',
    status: '已完结',
    rating: 8.9,
    views: 5670000,
    chapters: 86,
    updatedAt: '2026-06-15',
    description: '一座被诅咒的老宅，十个不为人知的诡异故事。每当夜幕降临，秘密便逐渐浮出水面...',
    tags: ['恐怖', '悬疑', '灵异', '短篇'],
  },
  {
    id: 7,
    title: '机甲狂潮',
    slug: 'jijia-kuangchao',
    cover: 'https://readdy.ai/api/search-image?query=A%20mecha%20Chinese%20manhua%20cover%20with%20giant%20robot%20in%20futuristic%20city%2C%20silver%20and%20cyan%20tones%2C%20sci-fi%20theme%2C%20stylized%20anime%20art%2C%20technological%20atmosphere%2C%20clean%20composition%2C%20high%20quality%20illustration&width=600&height=800&seq=comic-07&orientation=portrait',
    category: 'kehuan',
    author: '钢铁工厂',
    status: '连载中',
    rating: 9.2,
    views: 7230000,
    chapters: 142,
    updatedAt: '2026-08-01',
    description: '未来世界，机甲成为人类最强武器。少年驾驶着传说中的机甲，在星际战场上创造奇迹...',
    tags: ['机甲', '科幻', '未来', '战争'],
  },
  {
    id: 8,
    title: '笑傲校园',
    slug: 'xiaoao-xiaoyuan',
    cover: 'https://readdy.ai/api/search-image?query=A%20funny%20Chinese%20school%20comedy%20manhua%20cover%20with%20students%20laughing%2C%20bright%20yellow%20and%20green%20tones%2C%20slice%20of%20life%20theme%2C%20stylized%20anime%20art%2C%20cheerful%20atmosphere%2C%20clean%20composition%2C%20high%20quality%20illustration&width=600&height=800&seq=comic-08&orientation=portrait',
    category: 'gaoxiao',
    author: '开心漫画',
    status: '连载中',
    rating: 9.0,
    views: 8450000,
    chapters: 112,
    updatedAt: '2026-08-03',
    description: '校园里每天都在上演令人捧腹的搞笑日常，一群活宝同学的各种糗事让人笑到停不下来...',
    tags: ['搞笑', '校园', '日常', '轻松'],
  },
  {
    id: 9,
    title: '长安幻夜',
    slug: 'changan-huanye',
    cover: 'https://readdy.ai/api/search-image?query=A%20historical%20Chinese%20manhua%20cover%20set%20in%20ancient%20Changan%20city%2C%20elegant%20red%20and%20gold%20tones%2C%20ancient%20China%20theme%2C%20stylized%20anime%20art%2C%20palace%20atmosphere%2C%20clean%20composition%2C%20high%20quality%20illustration&width=600&height=800&seq=comic-09&orientation=portrait',
    category: 'guzhuang',
    author: '古风漫画',
    status: '连载中',
    rating: 9.7,
    views: 13400000,
    chapters: 268,
    updatedAt: '2026-08-04',
    description: '大唐长安，夜幕降临后的奇幻故事。少年与神秘少女的相遇，揭开了一段跨越千年的秘密...',
    tags: ['古装', '奇幻', '大唐', '爱情'],
  },
  {
    id: 10,
    title: '迷雾追踪',
    slug: 'miwu-zhuizong',
    cover: 'https://readdy.ai/api/search-image?query=A%20mystery%20Chinese%20manhua%20cover%20with%20detective%20in%20foggy%20street%2C%20gray%20and%20dark%20green%20tones%2C%20crime%20investigation%20theme%2C%20stylized%20anime%20art%2C%20noir%20atmosphere%2C%20clean%20composition%2C%20high%20quality%20illustration&width=600&height=800&seq=comic-10&orientation=portrait',
    category: 'xuanyi',
    author: '真相漫画',
    status: '已完结',
    rating: 9.1,
    views: 6120000,
    chapters: 72,
    updatedAt: '2026-05-20',
    description: '一桩离奇的案件，一个看似普通的侦探，在不断追踪真相的过程中，发现了令人震惊的内幕...',
    tags: ['悬疑', '推理', '犯罪', '都市'],
  },
  {
    id: 11,
    title: '桃花源记',
    slug: 'taohuayuan-ji',
    cover: 'https://readdy.ai/api/search-image?query=A%20fantasy%20Chinese%20manhua%20cover%20with%20peach%20blossom%20forest%20and%20hidden%20village%2C%20soft%20pink%20and%20green%20tones%2C%20utopia%20theme%2C%20stylized%20anime%20art%2C%20dreamy%20atmosphere%2C%20clean%20composition%2C%20high%20quality%20illustration&width=600&height=800&seq=comic-11&orientation=portrait',
    category: 'shaonian',
    author: '桃源创作',
    status: '连载中',
    rating: 9.5,
    views: 9780000,
    chapters: 164,
    updatedAt: '2026-08-02',
    description: '高中生偶然发现了一个隐藏在深山中的世外桃源，那里的一切都颠覆了他的认知...',
    tags: ['奇幻', '冒险', '少年', '成长'],
  },
  {
    id: 12,
    title: '龙族传说',
    slug: 'longzu-chuanshuo',
    cover: 'https://readdy.ai/api/search-image?query=A%20dragon%20fantasy%20Chinese%20manhua%20cover%20with%20golden%20dragon%20and%20warrior%2C%20gold%20and%20crimson%20tones%2C%20epic%20fantasy%20theme%2C%20stylized%20anime%20art%2C%20majestic%20atmosphere%2C%20clean%20composition%2C%20high%20quality%20illustration&width=600&height=800&seq=comic-12&orientation=portrait',
    category: 'xuanhuan',
    author: '龙渊漫画',
    status: '连载中',
    rating: 9.6,
    views: 14500000,
    chapters: 298,
    updatedAt: '2026-08-04',
    description: '龙族后裔少年觉醒血脉之力，在寻找失落龙族的过程中，逐步揭开万年之前的惊天秘密...',
    tags: ['龙族', '奇幻', '冒险', '史诗'],
  },
];

export const bannerComics = [
  {
    id: 9,
    title: '长安幻夜',
    slug: 'changan-huanye',
    cover: 'https://readdy.ai/api/search-image?query=A%20breathtaking%20Chinese%20historical%20manhua%20banner%20set%20in%20ancient%20Changan%2C%20palace%20silhouette%20against%20moonlight%2C%20elegant%20traditional%20architecture%2C%20warm%20golden%20and%20deep%20red%20tones%2C%20stylized%20anime%20art%2C%20cinematic%20wide%20composition%2C%20mysterious%20atmosphere%2C%20high%20quality%20illustration&width=1600&height=700&seq=banner-01&orientation=landscape',
    description: '大唐长安，夜幕降临后的奇幻故事',
    tag: '本周热门',
  },
  {
    id: 12,
    title: '龙族传说',
    slug: 'longzu-chuanshuo',
    cover: 'https://readdy.ai/api/search-image?query=A%20majestic%20Chinese%20dragon%20fantasy%20manhua%20banner%2C%20golden%20dragon%20soaring%20through%20clouds%2C%20epic%20scale%2C%20warm%20golden%20and%20deep%20blue%20sky%2C%20stylized%20anime%20art%2C%20cinematic%20wide%20composition%2C%20mythical%20atmosphere%2C%20high%20quality%20illustration&width=1600&height=700&seq=banner-02&orientation=landscape',
    description: '龙族后裔觉醒血脉之力',
    tag: '强力推荐',
  },
  {
    id: 1,
    title: '蜜桃少年',
    slug: 'mitao-shaonian',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20Chinese%20manhua%20banner%20with%20peach%20blossom%20trees%20and%20a%20young%20man%2C%20soft%20pink%20petals%20floating%2C%20warm%20sunlight%2C%20stylized%20anime%20art%2C%20cinematic%20wide%20composition%2C%20dreamy%20atmosphere%2C%20high%20quality%20illustration&width=1600&height=700&seq=banner-03&orientation=landscape',
    description: '少年林枫的成长冒险之旅',
    tag: '新作上线',
  },
];

export const hotRankings = [
  { rank: 1, id: 9, title: '长安幻夜', views: '1340万', trend: 'up' },
  { rank: 2, id: 12, title: '龙族传说', views: '1450万', trend: 'up' },
  { rank: 3, id: 1, title: '蜜桃少年', views: '1285万', trend: 'up' },
  { rank: 4, id: 5, title: '仙路争锋', views: '1050万', trend: 'down' },
  { rank: 5, id: 3, title: '花间少年', views: '1102万', trend: 'up' },
  { rank: 6, id: 4, title: '烈焰战魂', views: '892万', trend: 'up' },
  { rank: 7, id: 2, title: '星辰大海', views: '965万', trend: 'down' },
  { rank: 8, id: 8, title: '笑傲校园', views: '845万', trend: 'up' },
];

export const latestUpdates = [
  { id: 1, title: '蜜桃少年', chapter: '第186话 觉醒时刻', time: '10分钟前' },
  { id: 12, title: '龙族传说', chapter: '第298话 龙神降临', time: '25分钟前' },
  { id: 9, title: '长安幻夜', chapter: '第268话 月下之约', time: '1小时前' },
  { id: 4, title: '烈焰战魂', chapter: '第198话 终极一战', time: '2小时前' },
  { id: 5, title: '仙路争锋', chapter: '第320话 飞升之路', time: '3小时前' },
  { id: 3, title: '花间少年', chapter: '第156话 樱花树下', time: '5小时前' },
  { id: 8, title: '笑傲校园', chapter: '第112话 考试大作战', time: '6小时前' },
  { id: 11, title: '桃花源记', chapter: '第164话 秘境探秘', time: '8小时前' },
  { id: 7, title: '机甲狂潮', chapter: '第142话 终极机甲', time: '10小时前' },
  { id: 6, title: '幽夜诡谈', chapter: '第86话 终章：真相', time: '昨天' },
];